import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgArrowsClockwise = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 5.25v5.25a.875.875 0 0 1-.875.875h-5.25a.875.875 0 1 1 0-1.75h3.138l-1.6-1.6a8.702 8.702 0 0 0-6.14-2.563h-.049a8.697 8.697 0 0 0-6.113 2.49.875.875 0 0 1-1.222-1.25 10.5 10.5 0 0 1 14.765.086l1.596 1.6V5.25a.875.875 0 0 1 1.75 0Zm-4.111 14.797a8.75 8.75 0 0 1-12.302-.072l-1.6-1.6h3.138a.875.875 0 0 0 0-1.75h-5.25a.875.875 0 0 0-.875.875v5.25a.875.875 0 1 0 1.75 0v-3.138l1.6 1.6a10.437 10.437 0 0 0 7.369 3.076h.058a10.43 10.43 0 0 0 7.336-2.99.875.875 0 0 0-1.223-1.25h-.001Z" />
  </svg>
);
export default SvgArrowsClockwise;
